var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fill-height" },
    [
      _c(
        "v-app-bar",
        {
          attrs: {
            id: "main-app-bar",
            app: "",
            color: "white",
            "clipped-left": "",
            "clipped-right": ""
          }
        },
        [
          _c(
            "v-container",
            { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                {
                  staticClass: "company-id my-2 flex-nowrap",
                  attrs: {
                    align: "center",
                    "align-content": "center",
                    justify: "start",
                    "no-gutters": ""
                  }
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "my-2 pl-16",
                      attrs: { sm: "3", md: "6", lg: "9" }
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        { staticClass: "ml-5 title-spaced hidden-sm-and-down" },
                        [
                          _vm._l(this.route, function(node, keys) {
                            return _c(
                              "span",
                              { key: keys, staticClass: "node" },
                              [_vm._v(_vm._s(node))]
                            )
                          }),
                          _c("span", { staticClass: "green--text" }, [
                            _vm._v(_vm._s(this.title))
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "customer-name px-2 green--text text-right open-modal-button d1",
                      attrs: { sm: "6", md: "4", lg: "2" },
                      on: { click: _vm.openProfileModal }
                    },
                    [_vm._v(" " + _vm._s(this.contact.customer.name) + " ")]
                  ),
                  _c("v-divider", { attrs: { vertical: "" } }),
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "customer-username pl-2 pr-0 text-left open-modal-button d2",
                      attrs: { sm: "3", md: "2", lg: "1" },
                      on: { click: _vm.openProfileModal }
                    },
                    [
                      _vm._v(" Hola, "),
                      _c("strong", { staticClass: "green--text" }, [
                        _vm._v(_vm._s(this.contact.name))
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("ModalProfile", {
            key: "MPK",
            ref: "profileModal",
            attrs: { smallScreen: false },
            on: { success: _vm.userModified }
          }),
          _vm.$vuetify.breakpoint.smAndDown
            ? _c("v-app-bar-nav-icon", {
                on: {
                  click: function($event) {
                    _vm.drawer = !_vm.drawer
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-navigation-drawer",
        {
          ref: "navigationDrawer",
          staticClass: "max-width-override drawer-color",
          attrs: {
            app: "",
            clipped: "",
            dark: "",
            "expand-on-hover": !_vm.$vuetify.breakpoint.smAndDown,
            "mobile-breakpoint": "600",
            permanent: _vm.showFooter,
            width: "296",
            "mini-variant-width": "80",
            temporary: _vm.$vuetify.breakpoint.smAndDown
          },
          scopedSlots: _vm._u([
            {
              key: "append",
              fn: function() {
                return [
                  _vm.showFooter
                    ? _c(
                        "v-fade-transition",
                        { attrs: { "hide-on-leave": "" } },
                        [_c("layout-footer")],
                        1
                      )
                    : _vm._e()
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.drawer,
            callback: function($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer"
          }
        },
        [
          _c(
            "div",
            { staticClass: "drawer-content" },
            [
              _c("main-nav", {
                attrs: { nodes: _vm.menuItems, opened: _vm.showFooter }
              })
            ],
            1
          )
        ]
      ),
      _vm.showContent
        ? _c(
            "v-main",
            { staticClass: "fill-height", attrs: { id: "main-content" } },
            [
              _c(
                "div",
                { staticClass: "main-content fill-height" },
                [_vm._t("default")],
                2
              )
            ]
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            fullscreen: "",
            loading: _vm.loadingDaycoRoles,
            persistent: ""
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("DaycoRoleManagement", {
            key: _vm.daycoRolesKey,
            attrs: {
              createContact: true,
              createUser: false,
              activationMode: false,
              contactInfo: null
            },
            on: { closeDialog: _vm.closeDialog }
          })
        ],
        1
      ),
      _c("logout-modal", { ref: "logoutModal" }),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", timeout: _vm.timeout, color: "red" },
          model: {
            value: _vm.snackbarError,
            callback: function($$v) {
              _vm.snackbarError = $$v
            },
            expression: "snackbarError"
          }
        },
        [
          _vm._v(
            " Disculpe, en este momento no es posible contactar al servidor "
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: {
                click: function($event) {
                  _vm.snackbarError = false
                }
              }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", timeout: _vm.timeout, color: "green" },
          model: {
            value: _vm.snackbarSuccess,
            callback: function($$v) {
              _vm.snackbarSuccess = $$v
            },
            expression: "snackbarSuccess"
          }
        },
        [
          _vm._v(" El usuario fue modificado con éxito "),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: {
                click: function($event) {
                  _vm.snackbarSuccess = false
                }
              }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }